import { render, staticRenderFns } from "./TestProfilesMenu.vue?vue&type=template&id=51d3209a&scoped=true&"
import script from "./TestProfilesMenu.vue?vue&type=script&lang=js&"
export * from "./TestProfilesMenu.vue?vue&type=script&lang=js&"
import style0 from "./TestProfilesMenu.vue?vue&type=style&index=0&id=51d3209a&prod&lang=scss&scoped=true&"
import style1 from "./TestProfilesMenu.vue?vue&type=style&index=1&id=51d3209a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d3209a",
  null
  
)

export default component.exports